import { GroupType, PeoplePicker, PersonType } from "@microsoft/mgt-react";
import { useQueryClient } from "@tanstack/react-query";
import { Checkbox, message } from "antd";
import { HtmlEditor } from "devextreme-react";
import { Formik } from "formik";
import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { getEnv } from "../../../AppConfigs";
import { CreateNotification } from "../../../components/notifier";
import Spinner from "../../../components/spinner/Spinner";
import MESSAGES from "../../../constants/messages";
import PERMISSIONS from "../../../constants/permissions";
import { documentStatus } from "../../../constants/statusConstants";
import { useMineInfo } from "../../../contexts/mine-info-context";
import { getDocumentStatus, getDocumentStatusTitle, getNextDocumentStatus } from "../../../helper/dataHelper";
import {
  addDays,
  addYear,
  getDay,
  getDiffDay,
  getLocalDate,
  getUCTDate,
  setUtcTime,
} from "../../../helper/dateTimeHelper";
import { showDocumentPerrmissionAccessDenied } from "../../../helper/util";
import { useEmployee } from "../../../hook";
import { IFileDocumentInfo } from "../../../models/IFileDocumentInfo";
import { StatisticsEmployeeService } from "../../../services/department-viags/statistics-employee.service";
import { DocumentContentService } from "../../../services/document/document-content.service";
import { DefaultUserIdService } from "../../../services/document/document-default-user-id.service";
import { DocumentLinkService } from "../../../services/document/document-link.service";
import { DocumentService } from "../../../services/document/document.service";
import { FileService } from "../../../services/file/file.service";
import { buildPeopleJsonFromPicker, getQueryVariable } from "../../../services/util";
import DateRangeSelect from "../../procedure/meeting/range-time-select/DateRangeSelect";
import { PublicDepartmentList } from "../components/document/permission-department/public-department-list";
import { useEditorContentPermission } from "../editor-content-permission-context";
import useCreateFolder from "../hooks/documents/use-create-folder";
import { createFileContentForEditor, getTitleForEffectiveBaseOnStatus, htmlType } from "../util";

const EditDocumentProcessModal = (props: any) => {
  const { onClose, onUpdated, isOpen, data, isPublish, onInterPublish, isInterpublishStatus, isChangeApprover } = props;
  const [people, setPeople] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  // const [documentLinks, setDocumentLinks] = useState<any[]>([]);
  const [selectedDocumentLinks] = useState<any>([]);
  const today = new Date();
  const [startDate, setStartDate] = useState(today);
  const [endDate, setEndDate] = useState(addYear(today, 1));
  const [minDate, setMinDate] = useState(today);
  const [processStatusId, setProcessStatusId] = useState(documentStatus.new.id);
  const templateId = getQueryVariable("templateId");
  /* const [contents, setContents] = useState<any>();  */
  // const [defaultGroupId, setDefaultGroupId] = useState<any>([]);
  const [selectedUserId, setSelectedUserId] = useState<any>([]);
  const [isDefault, setIsDefault] = useState(false);
  const [isOpenDepartmentList, setIsOpenDepartmentList] = useState(false);
  const queryClient = useQueryClient();
  const { contentPermissions } = useEditorContentPermission();
  const { currentEmployee } = useEmployee();
  const [content, setContent] = useState("");

  const { checkPermission } = useMineInfo();

  const { mutateAsync: createFolderAsync } = useCreateFolder();

  const handleOnSubmit = async (values: any) => {
    if (people.length < 1) {
      CreateNotification({
        title: "Thông báo",
        body: "Anh/Chị vui lòng chọn cá nhân, đơn vị trước khi triển khai!",
        icon: "/icons/warning.png",
      });
      return;
    }

    setLoading(true);
    onInterPublish(true);
    try {
      const status = getDocumentStatus(processStatusId);
      // if (status.value === documentStatus.publish.value || status.value === documentStatus.interimpublish.value) {
      //   const index = people.findIndex(
      //     (e: any) => e.userPrincipalName?.toLowerCase() === currentUser?.username?.toLowerCase(),
      //   );
      //   if (index < 0) {
      //     const owner = {
      //       id: currentUser.localAccountId,
      //       displayName: currentUser.name,
      //       jobTitle: null,
      //       surname: currentUser.name,
      //       PersonType: {
      //         class: "Person",
      //         subclass: "OrganizationUser",
      //       },
      //       givenName: currentUser.name,
      //       userPrincipalName: currentUser.username.toLowerCase(),
      //       isView: true,
      //       isEdit: true,
      //     };
      //     people.push(owner);
      //   }
      // }

      const tmp = {
        effectiveFrom: setUtcTime(getDay(startDate)),
        effectiveTo: setUtcTime(getDay(endDate)),
        docNotes: content,
        subInfo: values.subject,
        docStatus: status.label,
        docStatusValue: status.value,
        docStatusId: status.id,
        fileAssignedTo: buildPeopleJsonFromPicker(people),
        docLinks: JSON.stringify(selectedDocumentLinks),
        isSendMail: true,
        isContentPermission: values.checked,
      };

      let fields: any = { ...tmp };

      const listIssusedUser = fields.fileAssignedTo ? JSON.parse(fields.fileAssignedTo) : [];

      const newListIssusedUser = listIssusedUser.map((e: any) => {
        return {
          departmentId: +e.departmentId!,
          employeeCode: e.Id,
          employeeEmail: e.email,
          departmentName: e.department,
          departmentCode: e.departmentCode,
        };
      });

      const statisticFields = {
        docId: data.docId && +data.docId,
        docCode: data.docCode,
        docName: data.Title,
        docType: data.docType,
        docStatus: fields.docStatus,
        publishDay: fields.effectiveFrom,
        effectiveDate: fields.effectiveTo,
        listIssusedUser: [...newListIssusedUser],
      };

      if (status.value === documentStatus.approval.value) {
        fields = {
          ...fields,
          // approvedDate: getUCTDate(),
          approvedBy: buildPeopleJsonFromPicker(people),
          docStatus: "Phê duyệt",
          approvalStatus: "approve",
        };
      }

      if (status.value === documentStatus.readytopublish.value) {
        fields = {
          ...fields,
          approvedDate: getUCTDate(),
          // approvedBy: buildPeopleJsonFromPicker(people),
          approvalStatus: "approve",
          approvedName: currentEmployee?.Title,
        };
      } else if (status.value === documentStatus.compose.value) {
        fields = {
          ...fields,
          docEditors: buildPeopleJsonFromPicker(people),
        };
      } else if (status.value === documentStatus.feedback.value) {
        fields = {
          ...fields,
          docReviewers: buildPeopleJsonFromPicker(people),
        };
      } else if (status.value === documentStatus.review.value) {
        fields = {
          ...fields,
          docDetectors: buildPeopleJsonFromPicker(people),
        };
      } else if (status.value === documentStatus.check.value) {
        fields = {
          ...fields,
          docCheckers: buildPeopleJsonFromPicker(people),
        };
      } else if (status.value === documentStatus.interimpublish.value) {
        await StatisticsEmployeeService.addPublishDocForUsers(statisticFields);
        await processPublicFromCustomEditor(data.id);
      } else if (status.value === documentStatus.publish.value) {
        fields.docPublicVersion = data.docPublicVersion + 1;
        await StatisticsEmployeeService.addPublishDocForUsers(statisticFields);
        await processPublicFromCustomEditor(data.id);
      }

      await DocumentService.updateFileInfo(data.id, fields);
      queryClient.invalidateQueries({ queryKey: ["document-info"] });
      //update file
      const fileInfoFields = {
        subInfo: fields.subInfo,
        docNotes: fields.docNotes,
        docStatusId: fields.docStatusId,
        docStatusValue: fields.docStatusValue,
        docStatus: fields.docStatus,
        Title: data.Title,
        docPublicVersion: data.docPublicVersion + 1,
        docEditionVersion: data.docEditionVersion,
        docPublishViewVersion: data.docPublishViewVersion,
        docEditTemp: data.docEditTemp,
      };

      await FileService.updateFileInfo(data.docId, fileInfoFields);
      queryClient.invalidateQueries({ queryKey: ["document-info"] });
      onUpdated();
      setLoading(false);
      // if ((status.value !== documentStatus.review.value && status.value !== documentStatus.interimpublish.value) || status.value !== documentStatus.readytopublish.value)
      //     CreateNotification({ title: 'Thành công', body: `Cập nhật thông tin thành công.`, icon: '/icons/success.png' });
    } catch (error: any) {
      CreateNotification({ title: "Cập nhật thông tin thất bại", body: error.toString(), icon: "/icons/error.png" });
      setLoading(false);
    }
  };

  const processPublicFromCustomEditor = async (docInfoId: any) => {
    var documentInfo = await DocumentService.get(docInfoId);

    if (!documentInfo) throw new Error("Không thể lấy thông tin tài liệu");

    const fileInfo = await FileService.getFile(documentInfo.fileId);

    if (!fileInfo) throw new Error("Không thể lấy thông tin tài liệu");

    //update content for working file
    let uploadedFile: any = null;
    if (documentInfo.IsCustomEditor) {
      const contents = await DocumentContentService.getList(templateId, documentInfo.fileId);
      uploadedFile = await createFileContentForEditor(htmlType(contents), fileInfo.name);
      await FileService.updateFile(uploadedFile, fileInfo.id);
    }

    //create empty public file
    const fileName = documentInfo.IsConvertToPDF ? fileInfo.nameWithoutExt + ".pdf" : fileInfo.name;
    uploadedFile = {
      content: "",
      size: 0,
      name: fileName,
    };
    //create public file info
    const publicSPListId = getEnv("REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID");
    const publicInfoSPListId = getEnv("REACT_APP_WORKING_DOCS_PUBLISH_INF_LIST_ID");
    let publicFile = await FileService.createFileWithFolderPath(
      uploadedFile,
      fileInfo.parentSubFolderPath,
      publicSPListId,
    );

    let folderId = publicFile.parentId || "";
    let parentFolderId = publicFile.parentId; // Đây chính là parent folder ID
    const ROOT_FOLDER_ID = getEnv("REACT_APP_DOCUMENT_FOLDER_ROOT_ID");
    const folderNames = (publicFile.parentSubFolderPath || "").split("/");
    let folderNameIndex = folderNames.length - 1;

    if (folderId)
      try {
        do {
          const folderInfo = await FileService.getFile(folderId, publicSPListId);
          parentFolderId = folderInfo.parentId; // Đây chính là parent folder ID

          await createFolderAsync({
            isPublicFolder: true,
            key: folderId,
            name: folderNames.at(folderNameIndex) || "",
            parentKey: parentFolderId === ROOT_FOLDER_ID ? undefined : parentFolderId,
            position: fileInfo.listItemId ?? undefined,
          });

          folderId = parentFolderId || "";
          folderNameIndex--;
        } while (parentFolderId !== ROOT_FOLDER_ID);
      } catch (error) {
        console.log("createFolderAsync", error);
      }

    if (!publicFile) throw new Error("Không thể tạo tài liệu ban hành");

    publicFile = await FileService.getFile(publicFile.id, publicSPListId);
    //find and update public file document info
    const publicDocumentInfo = await DocumentService.getPublicDocumentInfoFromWorkingDocument(documentInfo.listItemId);
    if (publicDocumentInfo) {
      const temp: IFileDocumentInfo = {
        ...documentInfo,
        effectiveTo: setUtcTime(getDay(endDate)),
        docId: publicFile.listItemId,
        fileId: publicFile.id,
        docWorkingId: documentInfo.docId,
        workingFileId: fileInfo.id,
        docReaders: null,
      };
      const fields = await DocumentService.mapDocumentInfoToFIelds(temp);
      await DocumentService.updateFileInfo(publicDocumentInfo.id, fields, publicInfoSPListId);
      await FileService.updateFileInfoFromDocumentInfo(publicFile.listItemId, fields, publicSPListId);
    } else {
      const temp = {
        ...documentInfo,
        effectiveTo: setUtcTime(getDay(endDate)),
        docId: publicFile.listItemId,
        fileId: publicFile.id,
        docWorkingId: documentInfo.docId,
        workingFileId: fileInfo.id,
        docReaders: null,
      };

      const fields = DocumentService.mapDocumentInfoToFIelds(temp);

      await FileService.createFileDocumentInfo(
        publicFile,
        publicFile.parentId,
        fields,
        publicSPListId,
        publicInfoSPListId,
      );
    }
    //copy content
    if (documentInfo.IsCustomEditor) {
      onInterPublish(false);
      if (documentInfo.docStatusValue === "check") {
      } else {
        await DocumentContentService.cloneFromTempalteToFile(
          fileInfo.id,
          publicFile.id,
          true,
          data.docPublicVersion + 1,
          null,
          contentPermissions,
        );
      }
    }
  };

  const handleSelectionChanged = (e: any) => {
    setPeople(e.target.selectedPeople);
  };

  const onStartDateChange = (date: any) => {
    const newDate = new Date(date);
    setStartDate(newDate);
    const days = getDiffDay(getLocalDate(newDate), getLocalDate(getDay(endDate)));
    if (days < 0) {
      setEndDate(newDate);
    }
    setTimeout(() => setMinDate(newDate), 0);
  };

  const onEndDateChange = (date: any) => {
    setEndDate(new Date(date));
  };

  // const openLink = (link: any) => {
  //   let url = link.docLinkUrl;
  //   if (link.docLinkId) url = Routes.documentDetail.path.replace(":id", link.docLinkId);

  //   if (url) openUrl(url);
  // };

  const getDocumentLink = () => {
    if (data && data.docId) {
      //load data here
      DocumentLinkService.getDocumentLinkInfos(data.docId).then(
        (res) => {
          // setDocumentLinks(res.data);
        },
        (error) => {
          if (error?.status === 403) {
            showDocumentPerrmissionAccessDenied();
          } else {
            CreateNotification({
              title: "Thông báo",
              body: "Không thể lấy thông tin liên kết",
              icon: "/icons/error.png",
            });
          }
        },
      );
    }
  };

  const getDefaultUserIdByStatus = () => {
    let status: number = data ? data.docStatusId + 1 : null;
    if (status) {
      DefaultUserIdService.getUserIdByStatus(status).then(
        (res) => {
          setSelectedUserId(res[0]?.fields.UserId?.split(","));
        },
        (error) => {
          console.error(error);
        },
      );
    }
  };

  const updateDefaultUserIdByStatus = async () => {
    let users: any = null;
    let userArr: any = null;
    if (people) {
      users = people.filter((user: any) => user.givenName?.length > 0);
      userArr = users.map((e: any) => e.id);
      const fields = {
        UserId: userArr.toString(),
      };
      const result = await DefaultUserIdService.updateUserIdByStatus(data.docStatusId + 1, fields);
      if (result) {
        CreateNotification({
          title: "Cập nhật thành công",
          body: "Đã đặt người dùng hiện tại làm mặc định",
          icon: "/icons/success.png",
        });
        setIsDefault(true);
        const timer = setTimeout(() => {
          setIsDefault(false);
        }, 3000);
        return () => {
          clearTimeout(timer);
        };
      }
    }
  };

  // const onSelectedDocument = (file: any, isSelected: boolean) => {
  //   const documents = selectedDocumentLinks;
  //   var selectedFile = documents.find((f: any) => f.id === file.id);

  //   if (selectedFile && isSelected === false) {
  //     const index = documents.indexOf(selectedFile);
  //     documents.splice(index, 1);
  //   } else if (!selectedFile && isSelected) {
  //     documents.push(file);
  //   }
  //   setSelectedDocumentLinks(documents);
  // };

  // const getGroupIdDefaultByStatus = (id: any) => {
  //   switch (id) {
  //     case documentStatus.new.id:
  //       return ["d10d2bc1-dc33-4157-af6b-69ad51c3dbb3"];
  //     case documentStatus.compose.id:
  //       return ["5a54ab0f-ae1e-4f97-a0e8-0525d4d4359e"];
  //     case documentStatus.feedback.id:
  //       return ["c08d7756-4a57-48fd-be26-ad299a4befee"];
  //     case documentStatus.review.id:
  //       return ["86fad17b-8951-40ee-b86e-279bb144aac3"];
  //     case documentStatus.interimpublish.id:
  //       return ["41e1525a-32ef-488d-bb20-c94b3b3f498a"];
  //     case documentStatus.approval.id:
  //       return ["d26b10c9-b3e4-4c4e-9bf2-326cf288ee7d"];
  //     case documentStatus.readytopublish.id:
  //       return ["751e2303-4450-4e12-b3a2-28b000cafe98"];
  //     case documentStatus.publish.id:
  //       return [null];
  //     default:
  //       return ["d10d2bc1-dc33-4157-af6b-69ad51c3dbb3"];
  //   }
  // };

  const onCloseDepartment = () => {
    setIsOpenDepartmentList(!isOpenDepartmentList);
  };

  const onConfirmPermission = (e: any) => {
    setPeople(e);
  };

  const openDepartmentList = () => {
    if (!checkPermission(PERMISSIONS.DEPLOY_DOCUMENT)) return message.error(MESSAGES.NOT_PERMISSION);

    setIsOpenDepartmentList(true);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getDocumentLink();
    }, 1000);
    return () => {
      clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    const nextStep = isChangeApprover ? getDocumentStatus(data?.docStatusId) : getNextDocumentStatus(data?.docStatusId);
    // setDefaultGroupId(getGroupIdDefaultByStatus(data?.docStatusId));
    getDefaultUserIdByStatus();
    setProcessStatusId(
      isPublish ? documentStatus.publish.id : isInterpublishStatus ? documentStatus.interimpublish.id : nextStep.id,
    );
    if (data?.docTypeId === "2") {
      setEndDate(addYear(today, 1));
    } else {
      setEndDate(isInterpublishStatus || isPublish ? addYear(today, 1) : addDays(today, 5));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isInterpublishStatus, isPublish, isOpen]);

  return (
    <Modal show={isOpen} onHide={onClose} centered size={"lg"} className="add-folder-modal">
      <Formik
        // validationSchema={addContentValidationSchema}
        onSubmit={handleOnSubmit}
        initialValues={{
          subject: data?.subInfo,
          content: "",
          checked: false,
        }}
      >
        {({ handleSubmit, handleChange, values, errors, setFieldValue }) => (
          <Form noValidate onSubmit={handleSubmit}>
            <Spinner show={loading} />
            <Modal.Header closeButton>
              <Modal.Title>{getDocumentStatusTitle(processStatusId)}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-4 px-4">
              {isPublish || isInterpublishStatus ? (
                <Form.Group>
                  <Button className="px-4 w-100 h-40" variant="success" onClick={openDepartmentList}>
                    Chọn đơn vị nhận triển khai tài liệu
                  </Button>
                </Form.Group>
              ) : (
                <>
                  <Form.Group as={Row} controlId="validationCustom01">
                    <Form.Label column sm={2} className="card-label">
                      {isPublish
                        ? "Ban hành tới"
                        : isInterpublishStatus
                        ? "Ban hành tạm thời tới"
                        : data?.docStatusId === documentStatus.approval.id
                        ? "Người thực hiện ban hành: "
                        : "Người thực thi"}
                    </Form.Label>
                    <Col sm={10}>
                      <div className="people_picker-custom">
                        <PeoplePicker
                          className="people-picker"
                          groupType={GroupType.distribution | GroupType.unified}
                          type={PersonType.any}
                          defaultSelectedUserIds={selectedUserId}
                          selectionChanged={handleSelectionChanged}
                        />
                      </div>
                    </Col>
                    <Form.Control.Feedback type="invalid">{errors.content}</Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group as={Row}>
                    <Form.Label column sm={8} className="card-label"></Form.Label>
                    <Col sm={4}>
                      <Button
                        className="px-4 w-100 h-40"
                        variant={isDefault ? "default" : "success"}
                        onClick={updateDefaultUserIdByStatus}
                      >
                        Lưu làm mặc định
                      </Button>
                    </Col>
                  </Form.Group>
                </>
              )}
              <Form.Group as={Row} controlId="validationCustom01">
                <Form.Label column sm={2} className="card-label">
                  {getTitleForEffectiveBaseOnStatus(processStatusId)}
                </Form.Label>
                <Col sm={10}>
                  <DateRangeSelect
                    onStartDateSelect={onStartDateChange}
                    onEndDateSelect={onEndDateChange}
                    startDate={startDate}
                    minDate={minDate}
                    endDate={endDate}
                  />
                </Col>
                <Form.Control.Feedback type="invalid">{errors.content}</Form.Control.Feedback>
              </Form.Group>
              {(processStatusId === documentStatus.interimpublish.id ||
                processStatusId === documentStatus.publish.id) && (
                <Form.Group as={Row} controlId="validationCustom01">
                  <Form.Label column sm={2} className="card-label">
                    {"Chủ đề"}
                  </Form.Label>
                  <Col sm={10}>
                    <Form.Control
                      required
                      as="textarea"
                      rows={1}
                      type="text"
                      name="subject"
                      value={values.subject}
                      onChange={handleChange}
                      isInvalid={!!errors.content}
                    />
                  </Col>
                  <Form.Control.Feedback type="invalid">{errors.subject}</Form.Control.Feedback>
                </Form.Group>
              )}
              <Form.Group as={Row} controlId="validationCustom01">
                <Form.Label column sm={2} className="card-label">
                  {"Ghi chú"}
                </Form.Label>
                <Col sm={10}>
                  <HtmlEditor
                    value={content}
                    onValueChanged={(e) => setContent(e.value)}
                    height={200} // Optional: Adjust the height as needed
                  />
                </Col>
                <Form.Control.Feedback type="invalid">{errors.content}</Form.Control.Feedback>
              </Form.Group>

              {(isPublish || isInterpublishStatus) && (
                <Form.Group as={Row} controlId="validationCustom01">
                  <Form.Label column sm={2} className="card-label">
                    <span style={{ color: "red" }}>* Lưu ý</span>
                  </Form.Label>
                  <Col sm={10}>
                    <Checkbox onChange={(value) => setFieldValue("checked", value.target.checked)}>
                      {" "}
                      Tài liệu cần phần quyền theo đoạn.
                    </Checkbox>
                  </Col>
                  <Form.Control.Feedback type="invalid">{errors.content}</Form.Control.Feedback>
                </Form.Group>
              )}
              {/* <Form.Group as={Row} controlId="validationCustom01">
                                <Form.Label column sm={2} className="card-label">{'Tài liệu liên kết'}</Form.Label>
                                <Col sm={10}>
                                    <div className="Table table-responsive-md">
                                        <table className='table table-hover'>
                                            <thead className='Table__Head'>
                                                <tr>
                                                    <th></th>
                                                    <th>Tên</th>
                                                    <th>Hiệu lực</th>
                                                </tr>
                                            </thead>
                                            <tbody className='Table__Body'>
                                                {
                                                    documentLinks.map((link: any, i: number) => (
                                                        <tr key={i}>
                                                            <td><InputCheckbox name="checkbox" label='' onTouched={() => false} onChange={(e) => onSelectedDocument(link, e)} value={undefined} /></td>        
                                                            <td onClick={() => { openLink(link) }}>{link.Title}<br/>{(link.docLinkStatus ? `Tình trạng: ${link.docLinkStatus}` : "")}</td>
                                                            <td>{getRangeDateText(link.effectiveFrom || link.docLinkEffectiveFrom, link.effectiveTo || link.docLinkEffectiveTo)}</td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </Col>
                                <Form.Control.Feedback type="invalid">{errors.content}</Form.Control.Feedback>
                            </Form.Group> */}
            </Modal.Body>
            <Modal.Footer>
              <Button onClick={onClose} variant="secondary">
                Hủy
              </Button>
              <Button type="submit" variant="info">
                Lưu
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
      <PublicDepartmentList
        isOpen={isOpenDepartmentList}
        onClose={onCloseDepartment}
        onConfirmPermission={onConfirmPermission}
        documentTitle={data?.Title}
      />
    </Modal>
  );
};

export default EditDocumentProcessModal;
